<template>
  <div class="player">
    <img
      class="avatar"
      :src="`https://mc-heads.net/avatar/${nickname}`"
      alt="playerhead"
    />
    <div class="nick">{{ nickname }}</div>
  </div>
</template>

<style lang="scss">
.player {
  display: flex;

  padding-top: 14px;
  margin-top: 14px;

  align-items: center;

  .nick {
    margin-left: 16px;
    font-family: "Manrope";
    font-size: 16px;
    font-weight: 700;
    color: white;
  }

  .avatar {
    width: 32px;
    height: 32px;

    border-radius: 5px;
  }
}
</style>

<script>
export default {
  name: "Player",
  props: {
    nickname: String,
  },
};
</script>
